import { render, staticRenderFns } from "./CustomerSearch.vue?vue&type=template&id=19f52d0d&scoped=true"
import script from "./CustomerSearch.vue?vue&type=script&lang=js"
export * from "./CustomerSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f52d0d",
  null
  
)

export default component.exports